export const tentacles = Object.freeze(
  [
    {
      id: 1,
      label: 'soil-3xs',
      urlSlug: 'soil-3xs',
      name: 'Soil 3XS',
      sensors: [
        {
          name: 'Moisture',
          label: 'moisture',
          description: 'Measure moisture of surrounding space',
          unit: '%',
          min: 0,
          max: 100,
        },
        {
          name: 'Light',
          label: 'light',
          description: 'Measure light of surrounding space',
          unit: '%',
          min: 0,
          max: 100,
        },
        {
          name: 'Temperature',
          label: 'temperature',
          description: 'Measure temperature of surrounding space',
          unit: '°C',
          min: -20,
          max: 100,
        },
      ],
    },
    {
      id: 5,
      name: 'Soil 3XT',
      label: 'soil-3xt',
      urlSlug: 'soil-3xt',
      sensors: [
        {
          name: 'Temperature',
          label: 'temperature',
          description: 'Measure temperature of surrounding space',
          unit: '°C',
          min: -20,
          max: 100,
        },
        {
          name: 'Moisture',
          label: 'moisture',
          description: 'Measure moisture of surrounding space',
          unit: '%',
          min: 0,
          max: 100,
        },
        {
          name: 'Light',
          label: 'light',
          description: 'Measure light of surrounding space',
          unit: '%',
          min: 0,
          max: 100,
        },
        {
          name: 'Battery',
          label: 'battery',
          description: 'Measure battery of unit',
          unit: '%',
          min: 0,
          max: 100,
        },
      ],
    },
    {
      id: 8,
      name: 'PoolBOY 2.0',
      label: 'poolboy-2.0',
      urlSlug: 'poolboy-2.0',
      sensors: [
        {
          name: 'pH',
          label: 'pH',
          description: 'Measure pH of surrounding space',
          unit: 'pH',
          min: 0,
          max: 100,
        },
        {
          name: 'Temperature',
          label: 'temperature',
          description: 'Measure temperature of surrounding space',
          unit: '°C',
          min: -20,
          max: 100,
        },
        {
          name: 'Battery',
          label: 'battery',
          description: 'Measure battery of unit',
          unit: '%',
          min: 0,
          max: 100,
        },
      ],
    },
    {
      id: 10,
      name: 'GasBOY',
      label: 'gasboy',
      urlSlug: 'gasboy',
      sensors: [
        {
          name: 'Pressure',
          label: 'pressure',
          description: 'Measure pressure of surrounding space',
          unit: 'Pa',
          min: 0,
          max: 100,
        },
        {
          name: 'Temperature',
          label: 'temperature',
          description: 'Measure temperature of surrounding space',
          unit: '°C',
          min: -20,
          max: 100,
        },
        {
          name: 'Battery',
          label: 'battery',
          description: 'Measure battery of unit',
          unit: '%',
          min: 0,
          max: 100,
        },
      ],
    },
    {
      id: 11,
      name: 'Dendro 2.0',
      label: 'dendro-2.0',
      urlSlug: 'dendro-2.0',
      sensors: [
        {
          name: 'Circumfence',
          label: 'circumfence',
          description: 'Measure circumfence of surrounding space',
          unit: 'Pa',
          min: 0,
          max: 100,
        },
        {
          name: 'Temperature',
          label: 'temperature',
          description: 'Measure temperature of surrounding space',
          unit: '°C',
          min: -20,
          max: 100,
        },
        {
          name: 'Battery',
          label: 'battery',
          description: 'Measure battery of surrounding space',
          unit: '%',
          min: 0,
          max: 100,
        },
      ],
    },
    {
        id: 13,
        name: 'Soil 4XT',
        label: 'soil-4xt',
        urlSlug: 'soil-4xt',
        sensors: [
            {
                name: 'Temperature',
                label: 'temperature',
                description: 'Measure temperature of surrounding space',
                unit: '°C',
                min: -20,
                max: 100,
            },
            {
                name: 'Moisture',
                label: 'moisture',
                description: 'Measure moisture of surrounding space',
                unit: '%',
                min: 0,
                max: 100,
            },
            {
                name: 'Battery',
                label: 'battery',
                description: 'Measure battery of unit',
                unit: '%',
                min: 0,
                max: 100,
            },
        ],
    },
      {
          id: 14,
          name: 'Soil3XT-D',
          label: 'soil3xt-d',
          urlSlug: 'soil3xt-d',
          sensors: [
              {
                  name: 'Temperature',
                  label: 'temperature',
                  description: 'Measure temperature of surrounding space',
                  unit: '°C',
                  min: -20,
                  max: 100,
              },
              {
                  name: 'Moisture',
                  label: 'moisture',
                  description: 'Measure moisture of surrounding space',
                  unit: '%',
                  min: 0,
                  max: 100,
              },
              {
                  name: 'Light',
                  label: 'light',
                  description: 'Measure light of surrounding space',
                  unit: '%',
                  min: 0,
                  max: 100,
              },
              {
                  name: 'Battery',
                  label: 'battery',
                  description: 'Measure battery of unit',
                  unit: '%',
                  min: 0,
                  max: 100,
              },
          ],
      },
      {
          id: 15,
          name: 'Soil4XT-D',
          label: 'soil4xt-d',
          urlSlug: 'soil4xt-d',
          sensors: [
              {
                  name: 'Temperature',
                  label: 'temperature',
                  description: 'Measure temperature of surrounding space',
                  unit: '°C',
                  min: -20,
                  max: 100,
              },
              {
                  name: 'Moisture',
                  label: 'moisture',
                  description: 'Measure moisture of surrounding space',
                  unit: '%',
                  min: 0,
                  max: 100,
              },
              {
                  name: 'Light',
                  label: 'light',
                  description: 'Measure light of surrounding space',
                  unit: '%',
                  min: 0,
                  max: 100,
              },
              {
                  name: 'Battery',
                  label: 'battery',
                  description: 'Measure battery of unit',
                  unit: '%',
                  min: 0,
                  max: 100,
              },
          ],
      },
      {
          id: 16,
          label: 'iTentacle',
          urlSlug: 'i-tentacle',
          name: 'iTentacle',
          sensors: [],
      },
  ].map(tentacle => Object.freeze(tentacle)),
);

export const dynamicTiming = Object(
  [
    {
      id: 1, label: 't1', value: 15, name: '15 minutes',
    },
    {
      id: 2, label: 't2', value: 30, name: '30 minutes',
    },
    {
      id: 3, label: 't3', value: 60, name: '1 hour',
    },
    {
      id: 4, label: 't4', value: 120, name: '2 hours',
    },
    {
      id: 5, label: 't5', value: 480, name: '8 hours',
    },
    {
      id: 6, label: 't6', value: 0, name: 'Power off',
    },
  ].map(timing => Object(timing)),
);

export const dynamicSensing = Object(
  [
    {
      id: 1, label: 'sens1', value: 1, name: 'Current Soil 3XT-4',
    },
    {
      id: 2, label: 'sens2', value: 2, name: 'Original 2x per hour',
    },
    {
      id: 3, label: 'sens3', value: 3, name: 'Moisture 4x per hour',
    },
    {
      id: 4, label: 'sens4', value: 4, name: 'Moisture 3x per 45 min',
    },
    {
      id: 5, label: 'sens5', value: 5, name: 'Moisture/Temp 2x per 30 min',
    },
    {
      id: 6, label: 'sens6', value: 6, name: 'Moisture/Temp/Light 2x per 30 min',
    },
  ].map(sensing => Object(sensing)),
);
